var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"l-challenge-grid"},_vm._l((_vm.challenges),function(challenge){return _c('ChallengeGridCell',{key:challenge.id,attrs:{"challenge":challenge,"is-challenge-visible":_vm.isChallengeVisible}},[_vm._t("default",null,{"challenge":challenge})],2)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }